<template>
    <asli-popup :show-close-button="true" v-model="displayModal" class="p-4">
        <div class="px-8 py-4">
            <asli-section-header class="my-[15px]">Quote has Expired</asli-section-header>
            <p class="text-sm mb-[15px]">This quote has expired. You can start a new quote below.</p>
            <button-bar class="flex-col sm:flex-row">
                <asli-button id="new-quote" color="primary" type="button" @click="goToHomePage">
                    New Home Quote
                </asli-button>
            </button-bar>
        </div>
    </asli-popup>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { AsliPopup, AsliButton, AsliSectionHeader } from "@mbs-npm/anpost-ui";
import { useProposalStore } from "@/stores/risk/risk";
import { useMainStore } from "@/stores/main";
import router from "@/router";
import { FORM_MODE, ROUTE_NAMES } from "@/router/types";
import { FormRouteName } from "@/router/utils";
import ButtonBar from "@/components/ButtonBar.vue";

const proposalStore = useProposalStore();
const mainStore = useMainStore();

const displayModal = computed({
    get: () => mainStore.displayQuoteExpiredModal,
    set: val => (mainStore.displayQuoteExpiredModal = val)
});

function goToHomePage() {
    displayModal.value = false;
    proposalStore.resetProposal();
    router.push({ name: FormRouteName(ROUTE_NAMES.AboutYou, FORM_MODE.CREATE) });
}
</script>
